/** Register the PWA service worker when the browser supports it. */
export function registerServiceWorker(): void {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  const register = () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL || ""}/sw.js`).catch((error) => {
      if (process.env.NODE_ENV === "development") {
        console.warn("[pwa] Service worker registration failed:", error);
      }
    });
  };

  if (document.readyState === "complete") {
    register();
  } else {
    window.addEventListener("load", register, { once: true });
  }
}
